import { connect } from 'react-redux';
import SelectProductForm from './component';

const mapStateToProps = state => ({
    initialValues: process.env.REACT_APP_PRELOAD_FORM === 'true'
        ? {
            product: '',
        }
        : {
            product: '',
        },
    selectproduct: state.selectproduct.get('selectproduct'),
});

export default connect(mapStateToProps, null)(SelectProductForm);
